<template>
  <AlertModal class="alert-socials-modal" v-bind="$attrs" v-on="$listeners">
    <slot />
    <ModalSocials class="mt-4" />
  </AlertModal>
</template>

<script>
import AlertModal from "./AlertModal";
import ModalSocials from "./ModalSocials";

export default {
  name: "AlertSocialsModal",
  inheritAttrs: false,
  components: {
    AlertModal,
    ModalSocials
  }
};
</script>

<style lang="scss"></style>
